export const mediaStateType = {
  successful: {
    text: `Successful`,
    value: 'Success',
    color: 'green',
    iconClass: 'check circle outline',
    aliasText: 'Success Image Uploads',
    helpText:
      'Total number of images that were successfully uploaded to the auction.',
  },
  pending: {
    text: `Pending`,
    aliasText: 'Pending Image Uploads',
    color: 'yellow',
    value: 'Pending',
    helpText:
      'Total number of images that are in the process of being uploaded to the auction, but not yet completed. This number should decrease with time.',
  },
  failed: {
    text: `Issues`,
    aliasText: 'Failed Image Uploads',
    iconClass: 'times circle outline',
    color: 'red',
    value: 'Failed',
    helpText: 'Total number of images that failed to uploaded to the auction.',
  },
};

export const getMediaUploadSummary = (
  successCount,
  pendingCount,
  issueCount,
  auctionID,
  auctionName,
  popupPosition,
) => {
  const auction = { auctionID, auctionName };
  const { successful, pending, failed } = mediaStateType;

  const successfulImages = {
    ...successful,
    ...{ qty: successCount },
    ...auction,
    ...{ popupPosition },
  };
  const pendingImages = {
    ...pending,
    ...{ qty: pendingCount },
    ...auction,
    ...{ popupPosition },
  };
  const failedImages = {
    ...failed,
    ...{ qty: issueCount },
    ...auction,
    ...{ popupPosition },
  };

  return [successfulImages, pendingImages, failedImages];
};
